import React from 'react';
import { Container} from 'react-bootstrap';
import CarouselBox from '../components/CarouselBox';


function AboutPage(props) {
    return(
        <div>
          <CarouselBox/>
            <Container fluid={false} style={{position:"relative",marginTop:"10px",padding:"50px"}}>
            
                <h1 style={{ color: "#233048"}}>О Компании</h1>
                <p style={{ color: "#233048" }}>Компания JUMO - мировой лидер в производстве контрольно-измерительных
                        приборов и средств автоматики, расположенная в городе Фульда (центральная Германия),
                        была основана в 1947 году Moritz Kurt Juchheim.
                        Семья Juchheim еще с 1907 года занималась выпуском датчиков температуры.
                 До 1947 года производство располагалось в Тюрингии.</p>
                <p style={{ color: "#233048" }}>Благодаря развитой сети филиалов JUMO по всему миру, Вы можете быть уверены в
                компетентной и своевременной технической поддержке, где бы Вы ни находились!</p>
                <p style={{ color: "#233048" }}>Философия компании JUMO - производство высококачественных и высокоточных приборов,
                        и максимально удобный для заказчиков сервис.
                 Компанией JUMO (Германия) выпускаются следующие приборы:</p>
                        <ul>
                    <li style={{ color: "#233048" }}>Приборы измерения/регулирования рН (в т.ч. переносные),
                окислительно-восстановительной способности и проводимости (регуляторы)</li>
                    <li style={{ color: "#233048" }}>Манометры - простые, мембранные, контактные, дистанционные</li>
                    <li style={{ color: "#233048" }}>Преобразователи давления (датчики давления) и дифференциального давления, реле перепада давления</li>
                    <li style={{ color: "#233048" }}>Термостаты и терморегуляторы в обычном и специальном исполнении, термопары</li>
                    <li style={{ color: "#233048" }}>Системы автоматического управления производственными процессами, в том числе распределённые</li>
                    <li style={{ color: "#233048" }}>Контроллеры</li>
                    <li style={{ color: "#233048" }}>Биметаллические и газонаполненные термометры</li>
                    <li style={{ color: "#233048" }}>Датчики температуры: термометры сопротивления и термопары</li>
                    <li style={{ color: "#233048" }}>Индикаторы</li>
                    <li style={{ color: "#233048" }}>Преобразователи сигналов от датчиков температуры в стандартный сигнал</li>
                    <li style={{ color: "#233048" }}>Бумажные и безбумажные самописцы и регистраторы процессов</li>
                        </ul>
                
                    
            </Container>
        
               

                 
         </div>
    );
};

export default AboutPage;